module.exports = __webpack_public_path__ + "img/question.419abf82.svg";